const translate = {
    "Monde": "Monde",
    "Afghanistan": "Afghanistan",
    "Albania": "Albanie",
    "Algeria": "Algérie",
    "Andorra": "Andorre",
    "Angola": "Angola",
    "Anguilla": "Anguilla",
    "Antigua and Barbuda": "Antigua-et-Barbuda",
    "Argentina": "Argentine",
    "Armenia": "Arménie",
    "Aruba": "Aruba",
    "Australia": "Australie",
    "Austria": "Autriche",
    "Azerbaijan": "Azerbaïdjan",
    "Bahamas": "Bahamas",
    "Bahrain": "Bahreïn",
    "Bangladesh": "Bangladesh",
    "Barbados": "Barbade",
    "Belarus": "Biélorussie",
    "Belgium": "Belgique",
    "Belize": "Belize",
    "Benin": "Bénin",
    "Bermuda": "Bermudes",
    "Bhutan": "Bhoutan",
    "Bolivia": "Bolivie",
    "Bosnia": "Bosnie",
    "Botswana": "Botswana",
    "Brazil": "Brésil",
    "British Virgin Islands": "Îles Vierges britanniques",
    "Brunei": "Brunei",
    "Bulgaria": "Bulgarie",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cabo Verde": "Cabo Verde",
    "Cambodia": "Cambodge",
    "Cameroon": "Cameroun",
    "Canada": "Canada",
    "Caribbean Netherlands": "Pays-Bas caribéens",
    "Cayman Islands": "Îles Caïmans",
    "Central African Republic": "République centrafricaine",
    "Chad": "Tchad",
    "Channel Islands": "Îles anglo-normandes",
    "Chile": "Chili",
    "China": "Chine",
    "Colombia": "Colombie",
    "Comoros": "Comores",
    "Congo": "Congo",
    "Costa Rica": "Costa Rica",
    "Croatia": "Croatie",
    "Cuba": "Cuba",
    "Curaçao": "Curaçao",
    "Cyprus": "Chypre",
    "Czechia": "Tchéquie",
    "Côte d'Ivoire": "Côte d'Ivoire",
    "DRC": "RDC",
    "Denmark": "Danemark",
    "Diamond Princess": "Diamond Princess",
    "Djibouti": "Djibouti",
    "Dominica": "Dominique",
    "Dominican Republic": "République dominicaine",
    "Ecuador": "Équateur",
    "Egypt": "Egypte",
    "El Salvador": "El Salvador",
    "Equatorial Guinea": "Guinée équatoriale",
    "Eritrea": "Érythrée",
    "Estonia": "Estonie",
    "Ethiopia": "Ethiopie",
    "Falkland Islands (Malvinas)": "Îles Falkland (Malvinas)",
    "Faroe Islands": "Îles Féroé",
    "Fiji": "Fidji",
    "Finland": "Finlande",
    "France": "France",
    "French Guiana": "Guyane française",
    "French Polynesia": "Polynésie française",
    "Gabon": "Gabon",
    "Gambia": "Gambie",
    "Georgia": "Géorgie",
    "Germany": "Allemagne",
    "Ghana": "Ghana",
    "Gibraltar": "Gibraltar",
    "Greece": "Grèce",
    "Greenland": "Groenland",
    "Grenada": "Grenade",
    "Guadeloupe": "Guadeloupe",
    "Guatemala": "Guatemala",
    "Guinea": "Guinée",
    "Guinea-Bissau": "Guinée-Bissau",
    "Guyana": "Guyane",
    "Haiti": "Haïti",
    "Holy See (Vatican City State)": "Saint-Siège (État de la Cité du Vatican)",
    "Honduras": "Honduras",
    "Hong Kong": "Hong Kong",
    "Hungary": "Hongrie",
    "Iceland": "Islande",
    "India": "Inde",
    "Indonesia": "Indonésie",
    "Iran": "Iran",
    "Iraq": "Iraq",
    "Ireland": "Irlande",
    "Isle of Man": "Ile de Man",
    "Israel": "Israël",
    "Italy": "Italie",
    "Jamaica": "Jamaïque",
    "Japan": "Japon",
    "Jordan": "Jordanie",
    "Kazakhstan": "Kazakhstan",
    "Kenya": "Kenya",
    "Kuwait": "Koweït",
    "Kyrgyzstan": "Kirghizistan",
    "Lao People's Democratic Republic": "République démocratique populaire lao",
    "Latvia": "Lettonie",
    "Lebanon": "Liban",
    "Lesotho": "Lesotho",
    "Liberia": "Libéria",
    "Libyan Arab Jamahiriya": "Jamahiriya arabe libyenne",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Lituanie",
    "Luxembourg": "Luxembourg",
    "MS Zaandam": "MS Zaandam",
    "Macao": "Macao",
    "Macedonia": "Macédoine",
    "Madagascar": "Madagascar",
    "Malawi": "Malawi",
    "Malaysia": "Malaisie",
    "Maldives": "Maldives",
    "Mali": "Mali",
    "Malta": "Malte",
    "Martinique": "Martinique",
    "Mauritania": "Mauritanie",
    "Mauritius": "Maurice",
    "Mayotte": "Mayotte",
    "Mexico": "Mexique",
    "Moldova": "Moldavie",
    "Monaco": "Monaco",
    "Mongolia": "Mongolie",
    "Montenegro": "Monténégro",
    "Montserrat": "Montserrat",
    "Morocco": "Maroc",
    "Mozambique": "Mozambique",
    "Myanmar": "Myanmar",
    "Namibia": "Namibie",
    "Nepal": "Népal",
    "Netherlands": "Pays-Bas",
    "New Caledonia": "Nouvelle-Calédonie",
    "New Zealand": "Nouvelle-Zélande",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigéria",
    "Norway": "Norvège",
    "Oman": "Oman",
    "Pakistan": "Pakistan",
    "Palestine": "Palestine",
    "Panama": "Panama",
    "Papua New Guinea": "Papouasie-Nouvelle-Guinée",
    "Paraguay": "Paraguay",
    "Peru": "Pérou",
    "Philippines": "Philippines",
    "Poland": "Pologne",
    "Portugal": "Portugal",
    "Qatar": "Qatar",
    "Romania": "Roumanie",
    "Russia": "Russie",
    "Rwanda": "Rwanda",
    "Réunion": "Réunion",
    "S. Korea": "Corée du Sud",
    "Saint Kitts and Nevis": "Saint-Kitts-et-Nevis",
    "Saint Lucia": "Sainte-Lucie",
    "Saint Martin": "Saint Martin",
    "Saint Pierre Miquelon": "Saint Pierre Miquelon",
    "Saint Vincent and the Grenadines": "Saint-Vincent-et-les Grenadines",
    "San Marino": "Saint-Marin",
    "Sao Tome and Principe": "Sao Tomé et Principe",
    "Saudi Arabia": "Arabie saoudite",
    "Senegal": "Sénégal",
    "Serbia": "Serbie",
    "Seychelles": "Seychelles",
    "Sierra Leone": "Sierra Leone",
    "Singapore": "Singapour",
    "Sint Maarten": "Sint Maarten",
    "Slovakia": "Slovaquie",
    "Slovenia": "Slovénie",
    "Somalia": "Somalie",
    "South Africa": "Afrique du Sud",
    "South Sudan": "Soudan du Sud",
    "Spain": "Espagne",
    "Sri Lanka": "Sri Lanka",
    "St. Barth": "Saint-Barth",
    "Sudan": "Soudan",
    "Suriname": "Suriname",
    "Swaziland": "Swaziland",
    "Sweden": "Suède",
    "Switzerland": "Suisse",
    "Syrian Arab Republic": "République arabe syrienne",
    "Taiwan": "Taiwan",
    "Tajikistan": "Tadjikistan",
    "Tanzania": "Tanzanie",
    "Thailand": "Thaïlande",
    "Timor-Leste": "Timor-Leste",
    "Togo": "Togo",
    "Trinidad and Tobago": "Trinité-et-Tobago",
    "Tunisia": "Tunisie",
    "Turkey": "Turquie",
    "Turks and Caicos Islands": "Îles Turques et Caïques",
    "UAE": "EAU",
    "UK": "UK",
    "USA": "USA",
    "Uganda": "Ouganda",
    "Ukraine": "Ukraine",
    "Uruguay": "Uruguay",
    "Uzbekistan": "Ouzbékistan",
    "Venezuela": "Venezuela",
    "Vietnam": "Vietnam",
    "Western Sahara": "Sahara occidental",
    "Yemen": "Yémen",
    "Zambia": "Zambie",
    "Zimbabwe": "Zimbabwe"
}
export default translate